export type TabsData = Record<string, any>;

export const getDataFromFormTabs = (tabs) =>
   tabs.reduce((acc, tab) => {
      Object.values(tab.elements).forEach((el: any) => {
         switch (el.type) {
            case "textarea":
            case "text":
               acc[el.tech_name] = el.value;
               break;
            case "file":
               acc[el.tech_name] = el.link;
               break;
            case "select":
               acc[el.tech_name] = el.options[el.value];
               break;
            case "listTable":
               acc[el.tech_name] = el.num1;
               break;
            case "button":
               if (!acc.buttons) acc.buttons = [];
               acc.buttons.push(el.tech_name);
               break;
            default:
               break;
         }
      });
      return acc;
   }, {} as TabsData);
